import {
  TrashIcon,
  MagnifyingGlassPlusIcon,
} from "@heroicons/react/24/outline";
import { Option, Select } from "@material-tailwind/react";
import "moment/locale/th";
import moment from "moment/moment";
import React, { useEffect, useState, useContext } from "react";
import { HashLoader } from "react-spinners";
import icon__plus from "../../../asset/icon/plus-small.svg";
import icon__search from "../../../asset/icon/search.svg";
import * as adminApi from "../../../service/adminApi";
import Input from "../../material/input/Input";
import ModalAddData from "../../material/modal/ModalAddData";
import PageHeader from "../../pageheader/PageHeader";
import Pagination from "../../pagination/Pagination";
import MenuAdmin from "../navAdmin/Menu";
import styles from "../TableManage.module.css";
import ModalUploadFileV2 from "../../material/modal/ModalUploadFileV2";
import { useLocation, useNavigate } from "react-router";
import { RedirectCode400 } from "../../RedirectCode400";
import design from "../UserManament.module.css";

import { CurrentUserContext } from "../../../App";

import Breadcrumb from "../../breadcrumb/breadcrumb";

import DataTable from "react-data-table-component";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function ManageWebsite() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const [selectValueOption, setSelectValueOption] = useState("4");
  const [date, setDate] = useState("");
  const [inputvalue, setInputValue] = useState("");
  const [activeBtn, setActiveBtn] = useState("เอกสารที่เกี่ยวข้อง");
  const [openModalAddData, setOpenModalAddData] = useState(false);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);

  const [documentList, setDocumentList] = useState([]);
  const [documentListStorage, setDocumentListStorage] = useState([]);
  const [page, setPage] = useState(1);
  const [amount, setAmount] = useState(0);
  const [maxPage, setMaxPage] = useState(1);
  const [totalDocument, setTotalDocument] = useState(null);

  const [guidelineList, setGuidelineList] = useState([]);
  const [guidelineListStorage, setGuidelineListStorage] = useState([]);
  const [page2, setPage2] = useState(1);
  const [maxPage2, setMaxPage2] = useState(1);
  const [totalGuideline, setTotalGuideline] = useState(null);

  const [announcementList, setAnnouncementList] = useState([]);
  const [announcementListStorage, setAnnouncementListStorage] = useState([]);
  const [page3, setPage3] = useState(1);
  const [maxPage3, setMaxPage3] = useState(1);
  const [totalAnnouncement, setTotalAnnouncement] = useState(null);

  const [questionnaireList, setQuestionnaireList] = useState([]);
  const [questionnaireListStorage, setQuestionnaireListStorage] = useState([]);
  const [page4, setPage4] = useState(1);
  const [maxPage4, setMaxPage4] = useState(1);
  const [totalQuestionnaire, setTotalQuestionnaire] = useState(null);

  const [labClassifyList, setLabClassifyList] = useState([]);
  const [labclassifyListStorage, setLabClassifyListStorage] = useState([]);
  const [pageLab, setPageLab] = useState(1);
  const [maxPageLab, setMaxPageLab] = useState(1);

  //ใช้ default ค่า ใน modal
  const [showDetail, setShowDetail] = useState(false);
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    // console.log(location.state);
    setDate(moment().add(543, "years").format("DD MMMM YYYY"));
    if (location.state?.type) {
      setActiveBtn(location.state?.type);
    }
    if (location.state?.option) {
      setSelectValueOption(location.state?.option);
    }

    // console.log(location.state);
  }, []);

  // console.log(selectValueOption);

  const handleChange = (event) => {
    //ใช้material-tailwind/react ไม่ต้อง target.value
    setSelectValueOption(event);
    setInputValue("");
  };

  //ใช้ get api แนวทางการตรวจและวรรณกรรมที่เกี่ยวข้อง
  useEffect(() => {
    if (activeBtn === "เอกสารที่เกี่ยวข้อง") {
      getDocumentList();
    } else if (activeBtn === "แนวทางการตรวจ") {
      getGuideline();
    }
  }, [page, page2, activeBtn]);

  useEffect(() => {
    if (selectValueOption === "3") {
      //ใช้ get apiเพิ่มข่าวสารประชาสัมพันธ์
      getContent();
    } else if (selectValueOption === "4") {
      //ใช้ get api แบบสอบถาม
      getQuestionnaire();
    } else if (selectValueOption === "2") {
      //ใช้อ่านข้อมูลขัดกรองผลแลป
      getLabClassifyList();
    }
  }, [page3, page4, pageLab, selectValueOption]);

  const getDocumentList = async () => {
    setLoading(true);
    let res = await adminApi.getDocument(page, 10);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDocumentList(res["data"]["document_list"]);
        setDocumentListStorage(res["data"]["document_list"]);
        setAmount(res["data"]["amount"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotalDocument(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDocumentList([]);
    }
  };

  const addDocument = async (event) => {
    let formData = new FormData();
    formData.append("file", event.file);
    formData.append("file_name", event.inputValue);
    setLoading(true);
    let res = await adminApi.addDocument(formData);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        setOpenModalUploadFile(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeDocument = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["document_name"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeDocument(item["document_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDocumentList([]);
    }
  };

  const getGuideline = async () => {
    setLoading(true);
    let res = await adminApi.getGuideline(page2, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setGuidelineList(res["data"]["guideline_list"]);
        // console.log(res["data"]);
        setGuidelineListStorage(res["data"]["guideline_list"]);
        setMaxPage2(Math.ceil(res["data"]["amount"] / 10));
        setTotalGuideline(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  //อันนี้อันเก่า  ถูกใช้ที่ component AddDataUseQuillEditor แล้ว
  const addGuideline = async (title, detail) => {
    setLoading(true);
    let res = await adminApi.addGuideline(title, detail);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        getGuideline();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeGuideline = async (item) => {
    // console.log(item);
    if (!window.confirm(`คุณต้องการลบ ${item["title"] || "-"} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeGuideline(item["guideline_id"]);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  //ประชาสัมพันธ์
  const getAnnouncement = async () => {
    setLoading(true);
    let res = await adminApi.getAnnouncement(page3, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setAnnouncementList(res["data"]["announcement_list"]);
        setAnnouncementListStorage(res["data"]["announcement_list"]);
        setMaxPage3(Math.ceil(res["data"]["amount"] / 10));
        setTotalAnnouncement(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeAnnouncement = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeAnnouncement(item["announcement_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getContent();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setAnnouncementList([]);
      setAnnouncementListStorage([]);
    }
  };

  //เนื้อหา
  const getContent = async () => {
    setLoading(true);
    let res = await adminApi.getContent(page3, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setAnnouncementList(res["data"]["content_list"]);
        setAnnouncementListStorage(res["data"]["content_list"]);
        setMaxPage3(Math.ceil(res["data"]["amount"] / 10));
        setTotalAnnouncement(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeContent = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeContent(item["content_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getContent();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setAnnouncementList([]);
      setAnnouncementListStorage([]);
    }
  };

  const getQuestionnaire = async () => {
    setLoading(true);
    let res = await adminApi.getQuestionnaire(page4, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setQuestionnaireList(res["data"]["questionnaire_list"]);
        setQuestionnaireListStorage(res["data"]["questionnaire_list"]);
        setMaxPage4(Math.ceil(res["data"]["amount"] / 10));
        setTotalQuestionnaire(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const addQuestionnaire = async (title, detail) => {
    setLoading(true);
    let res = await adminApi.addQuestionnaire(title, detail);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setOpenModalAddData(false);
        getQuestionnaire();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeQuestionnaire = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"]} ใช่หรือไม่`)) {
      return;
    }
    // setLoading(true)
    let res = await adminApi.removeQuestionnaire(item["questionnaire_id"]);
    // setLoading(false)
    if (res) {
      if (res["data"]["code"] === 200) {
        getQuestionnaire();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setQuestionnaireList([]);
      setQuestionnaireListStorage([]);
    }
  };

  const getLabClassifyList = async () => {
    setLoading(true);
    let res = await adminApi.getLabClassifyList(page, 10);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setLabClassifyList(res["data"]["lab_classify_list"]);
        setLabClassifyListStorage(res["data"]["lab_classify_list"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const handleClickOpen = (booleanModal, type) => {
    if (type === "addData") {
      setShowDetail(false);
      setOpenModalAddData(booleanModal);
    } else if (type === "viewData") {
      setShowDetail(true);
      setOpenModalAddData(booleanModal);
    }
  };

  const handleClickClose = (booleanModal) => {
    setOpenModalAddData(booleanModal);
  };

  const onClickSearchDataTableDoc = (type) => {
    if (type === "searchDoc") {
      //เช็ค value ถ้าว่างให้เก็บ state ที่เก็บข้อมูลเก่า ไว้ จะได้ไม่ต้องยิง api หลายรอบ
      if (inputvalue !== "") {
        const filterTableSearchDoc = documentList.filter((item) => {
          return item["document_name"]
            ?.toLowerCase()
            .includes(inputvalue?.toLowerCase());
        });
        // console.log(filterTableSearchDoc)
        setDocumentList(filterTableSearchDoc);
      } else {
        setDocumentList(documentListStorage);
      }
    } else if (type === "searchLab") {
      if (inputvalue !== "") {
        const filterTableSearchLab = guidelineList.filter((item) => {
          return item["title"]
            ?.toLowerCase()
            .includes(inputvalue?.toLowerCase());
        });
        // console.log(filterTableSearchLab)
        setGuidelineList(filterTableSearchLab);
      } else {
        setGuidelineList(guidelineListStorage);
      }
    } else if (type === "searchPublicSign") {
      if (inputvalue !== "") {
        const filterTableSearchLab = announcementList.filter((item) => {
          //อยากให้ค่าอะไร ต้องใช้  filed นั้นเทียบ กับ value input
          return item["title"]
            ?.toLowerCase()
            .includes(inputvalue?.toLowerCase());
        });
        // console.log(filterTableSearchLab);
        setAnnouncementList(filterTableSearchLab);
      } else {
        setAnnouncementList(announcementListStorage);
      }
    } else if (type === "searchQuestionnaire") {
      if (inputvalue !== "") {
        const filterTableSearch = questionnaireList.filter((item) => {
          return item["title"]
            ?.toLowerCase()
            .includes(inputvalue?.toLowerCase());
        });
        setQuestionnaireList(filterTableSearch);
      } else {
        setQuestionnaireList(questionnaireListStorage);
      }
    } else if (type === "searchLabClassify") {
      if (inputvalue !== "") {
        const filterTableSearch = labClassifyList.filter((item) => {
          return item["lab_type_name"]
            ?.toLowerCase()
            .includes(inputvalue?.toLowerCase());
        });
        setLabClassifyList(filterTableSearch);
      } else {
        setLabClassifyList(labclassifyListStorage);
      }
    } else {
      setIsMessage({ type: "error", data: "ไม่พร้อมใช้งาน" });
    }
  };

  const toComponentCreate = (type, item) => {
    if (type === "guideline") {
      navigate("/managewebsite/AddDataUseQuillEditor", {
        state: {
          type: type,
          data: item,
        },
      });
    } else if (type === "newsPublicSign") {
      navigate("/managewebsite/AddDataUseQuillEditor", {
        state: {
          type: type,
          //อันนี้วางไว้เฉยๆ เพราะในอนาคตต้องมาทำเหมือน guideline
          data: item,
        },
      });
    } else {
      // console.log(type, "log จาก ManageWebsite");
    }
  };

  const toComponentEdit = (type, item) => {
    // console.log(type);
    if (type === "LabEditTestKit") {
      navigate("/admin/AddEditLabTestData", {
        state: {
          lab_data: {
            lab_classify_id: item.lab_classify_id,
            lab_result: item.lab_result,
            lab_type_key: item.lab_type_key,
            lab_type_name: item.lab_type_name,
          },
        },
      });
    }
  };

  const removeLabClassify = async (item) => {
    // console.log(item["lab_classify_id"]);
    if (!window.confirm(`คุณต้องการลบ ${item["lab_type_name"]} ใช่หรือไม่`)) {
      return;
    }
    // setLoading(true)
    let res = await adminApi.removeLabClassify(item["lab_classify_id"]);
    // setLoading(false)
    if (res) {
      if (res["data"]["code"] === 200) {
        getLabClassifyList();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setLabClassifyList([]);
      setLabClassifyListStorage([]);
    }
  };

  const columnsDoc = [
    {
      name: "ลำดับที่",
      selector: (item, index) => <div>{10 * (page - 1) + 1 + index}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อ",
      selector: (item) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left"
          onClick={() => {
            window.open(item["document_file"]);
          }}
        >
          {item["document_name"]}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (item) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeDocument(item);
            }}
            className="md:w-3 w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
      width: "20%",
    },
  ];

  const columnsCheck = [
    {
      name: "ลำดับที่",
      selector: (item, index) => <div>{10 * (page2 - 1) + 1 + index}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อ",
      selector: (item) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left"
          onClick={() => {
            toComponentCreate("guideline", item);
          }}
        >
          {item["title"] || "-"}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (item) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeGuideline(item);
            }}
            className="md:w-3 w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
      width: "20%",
    },
  ];

  const columns2 = [
    {
      name: "ลำดับที่",
      selector: (i, idx) => <div>{10 * (page3 - 1) + 1 + idx}</div>,
      width: "20%",
    },
    {
      name: "ชื่อชุดการตรวจ",
      selector: (i) => (
        <div onClick={() => {}} className=" text-[#000000] text-left">
          {i["lab_type_name"]}
        </div>
      ),
      wrap: true,
    },
    {
      name: "รายละเอียด",
      selector: (i) => (
        <div className="flex justify-center items-center">
          <button
            onClick={() => {
              toComponentEdit("LabEditTestKit", i);
            }}
            className="button-theme-pg p-0 flex justify-center items-center md:text-[12px] md:w-[90px] md:h-[25px] w-[110px] h-[30px] bg-[#FF9768] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-orange "
          >
            {"ดูรายละเอียด"}
          </button>
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (i) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeLabClassify(i);
            }}
            className="md:w-3 w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
    },
  ];

  const columns3 = [
    {
      name: "ลำดับที่",
      selector: (i, idx) => <div>{10 * (page3 - 1) + 1 + idx}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อ",
      selector: (i) => (
        <div
          onClick={() => {
            toComponentCreate("newsPublicSign", i);
          }}
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left"
        >
          {i["title"]}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (i) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeContent(i);
            }}
            className="md:w-3 w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
    },
  ];

  const columns4 = [
    {
      name: "ลำดับที่",
      selector: (item, index) => <div>{10 * (page4 - 1) + 1 + index}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อแบบสอบถาม",
      selector: (item) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#526F65] text-left"
          onClick={() => {
            window.open(item["url"]);
          }}
        >
          {item["title"]}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (item) => (
        <div className="flex justify-center gap-10">
          <MagnifyingGlassPlusIcon
            onClick={() => {
              setTitle(item["title"]);
              setDetail(item["url"]);
              handleClickOpen(true, "viewData");
            }}
            className="md:w-3 w-6 stroke-[#07842f] hover:cursor-pointer"
          />
          <TrashIcon
            onClick={() => {
              removeQuestionnaire(item);
            }}
            className="md:w-3 w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
    },
  ];

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "จัดการข้อมูลเว็บไซด์", url: "/managewebsite" },
    {
      name: "เพิ่มแบบสอบถามสำหรับประชาชน",
      url: "/managewebsite/add-questionnaire",
    },
  ];

  return (
    <div className="global-page">
      {/* modal adddata แนวทางการตรวจ */}
      {openModalAddData ? (
        <>
          <ModalAddData
            onClose={() => {
              handleClickClose(false);
            }}
            titlename="เพิ่มลิ้งค์แบบสอบถาม"
            showDetail={showDetail}
            labelInputName={"ชื่อแบบสอบถาม"}
            labelTextAreaName={"แนบลิ้งค์แบบสอบถาม (จาก Google form)"}
            defaultTitle={title}
            defaultDetail={detail}
            onSubmit={(e) => {
              if (window.confirm("ยืนยันการบันทึก")) {
                addQuestionnaire(e.title, e.detail);
              }
            }}
          />
        </>
      ) : null}

      <ModalUploadFileV2
        show={openModalUploadFile}
        title={"อัพโหลดไฟล์เอกสาร"}
        placeholder={"ชื่อเอกสาร"}
        titlename={"อัพโหลดไฟล์เอกสาร"}
        onSubmit={addDocument}
        onClose={() => {
          setOpenModalUploadFile(false);
        }}
      />

      <MenuAdmin menuActive="managewebsite" />
      <Breadcrumb pathItems={pathItems} />
      {/* <PageHeader titlename={'จัดการข้อมูลเว็บไซต์'} /> */}
      <div className="mt-[60px]"></div>

      <div>
        {!loading ? (
          <>
            <div className="mt-10">
              <div className="md:text-[48px] text-4xl">
                เพิ่มแบบสอบถามสำหรับประชาชน
              </div>
              <br></br>
              <div className="flex items-stretch md:flex-col md:gap-1 gap-3">
                <div className="md:text-[16px] text-xl">
                  รายการแบบสอบถามทั้งหมด
                </div>
                <div className="md:text-[12px] text-[#000000] self-center lg:self-start">{`(ข้อมูลวันที่ ${date})`}</div>
              </div>
              <div className="md:text-[12px] text-[#000000] mt-2 mb-2">{`จำนวน ${totalQuestionnaire} หัวข้อ`}</div>
              <div className={design.align}>
                <div className={design.alignSelect}>
                  <Input
                    disabledLabel={true}
                    placeholder="ค้นหาด้วยชื่อเอกสาร"
                    value={inputvalue}
                    setValue={setInputValue}
                  />
                  <button
                    style={{ marginLeft: "5%" }}
                    className="button-theme-pg flex justify-center items-center md:w-20 w-28 md:h-7 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan "
                    onClick={() => {
                      onClickSearchDataTableDoc("searchQuestionnaire");
                    }}
                  >
                    <img
                      className="stroke-[#526F65] w-4"
                      src={icon__search}
                      alt=""
                    />
                    <div className="md:text-[12px] text-sm text-[#000000]">
                      ค้นหา
                    </div>
                  </button>
                </div>
                <button
                  className="button-theme-pg flex justify-center items-center md:h-7 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan "
                  onClick={() => {
                    handleClickOpen(true, "addData");
                  }}
                >
                  <img
                    className="stroke-[#526F65] w-3"
                    src={icon__plus}
                    alt=""
                  />
                  <div className="md:text-[12px] text-sm text-[#000000]">
                    เพิ่มแบบสอบถาม
                  </div>
                </button>
              </div>
            </div>
            <div className={styles.align}>
              <DataTable
                className="classTable"
                columns={columns4}
                data={questionnaireList}
                customStyles={customStyles}
                noDataComponent={
                  <div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>
                }
              />
            </div>
            <Pagination
              page={page4}
              totalpage={maxPage4}
              clickForward={() => {
                if (page4 < maxPage4) {
                  setPage4(page4 + 1);
                }
              }}
              clickBackward={() => {
                if (page4 > 1) {
                  setPage4(page4 - 1);
                }
              }}
            />
          </>
        ) : (
          <HashLoader
            loading={true}
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "20px",
            }}
            color="#FF9768"
          />
        )}
      </div>
    </div>
  );
}

export default ManageWebsite;
